import React from "react"
import Frame from "@components/frame"
import ColTitle from "@components/colTitle"
import classnames from "@utils/classnames"
import styles from "./frameLogos.module.scss"

const FrameLogos = React.memo(({ title, sub, desc, logos, ...props }) => {
  return (
    <Frame.OutlineContainer>
      <Frame
        {...props}
        className={classnames(styles.collect, props.className)}
        clickable
      >
        <div className={styles.collectText}>
          <ColTitle sub={sub} className={styles.colTitle}>
            {title}
          </ColTitle>
          <p>{desc}</p>
          <Frame.ButtonContainer>
            <Frame
              type="button"
              clickable={false}
              className={styles.showAllBtn}
            >
              查看全部游戏
            </Frame>
          </Frame.ButtonContainer>
        </div>
        <div className={styles.collectImage}>
          {logos.map((logo, i) => {
            return (
              <img key={i} src={logo} className={styles[`collect${i + 1}`]} />
            )
          })}
        </div>
      </Frame>
    </Frame.OutlineContainer>
  )
})

FrameLogos.displayName = "FrameLogos"
export default FrameLogos
